/**
 * Waypoint travel's words (ADR-137 decision 24, P2.11-T38), every one a draft for the author: the world map's Travel
 * button and its travel mode (the title from a place or from here, the list's heading, "Free", a line's Focus, the
 * unnamed shrine's and waypoint's names, the reasons a line is dimmed), the channel bar's words, and the message line
 * for each refusal and break code the map server sends (`refused` and `broken` by code, `unknown` for a code a later
 * server names).
 */
export const TRAVEL = {
  button: "Travel",
  travel: "Travel",
  fromPlace: "Travel from {name}",
  fromHere: "Travel from here",
  places: "Destinations",
  none: "No place to travel to yet.",
  free: "Free",
  focus: "{count} Focus",
  shrine: "A shrine",
  waypoint: "A waypoint",
  otherMap: "{name}, {map}",
  dimmed: {
    short: "Not enough coin",
    focus: "Not enough Focus",
    outlaw: "Outlaws are turned away",
    unknown: "Not now",
  },
  channel: "Travelling to {name}",
  interrupted: "Travel interrupted",
  refused: {
    combat: "You can't travel while in combat.",
    duel: "You can't travel during a duel.",
    frozen: "You can't travel right now.",
    transfer: "You can't travel right now.",
    combatant: "You can't travel while marked a Combatant.",
    outlaw: "Outlaws are turned away from sanctuaries.",
    dead: "You can't travel right now.",
    busy: "You are already travelling.",
    short: "Not enough coin.",
    focus: "Not enough Focus.",
    weary: "You are still travel-weary.",
    stale: "That offer has passed. Open travel again.",
    moved: "You moved, so the offer has passed.",
    unknown: "You can't travel right now.",
  },
  broken: {
    damaged: "Travel interrupted: you were hit.",
    moved: "Travel interrupted: you moved.",
    cancelled: "Travel cancelled.",
    unknown: "Travel interrupted.",
  },
} as const;
